import styled from 'styled-components';
import { minWidth } from '../../styles';
export const Mask = styled.div `
  overflow: hidden;
`;
export const Frame = styled.div `
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
export const Track = styled.div `
  align-items: stretch;
  display: flex;
`;
export const Slide = styled.div `
  box-sizing: content-box;
  user-select: none;
  width: 100%;
  img {
    //so images wont be 'lifted' by mouse-dragging
    pointer-events: none;
  }
`;
export const Controls = styled.div `
  align-items: center;
  justify-content: space-around;
  gap: 1.5rem;
  @media ${minWidth.lg} {
    justify-content: ${({ alignStart }) => alignStart ? 'flex-start' : 'flex-end'};
  }
`;
export const MobileControls = styled(Controls) `
  display: flex;
  @media ${minWidth.lg} {
    display: none;
  }
`;
export const DesktopControls = styled(Controls) `
  display: none;
  @media ${minWidth.lg} {
    display: flex;
  }
`;
export const Dots = styled.div `
  align-items: center;
  display: ${({ mobile }) => (mobile ? 'flex' : 'none')};
  gap: 0.5rem;
  @media ${minWidth.lg} {
    display: ${({ desktop }) => (desktop ? 'flex' : 'none')};
  }
`;
export const Dot = styled.button `
  background-color: currentcolor;
  border: 0;
  border-radius: 0.25rem;
  color: inherit;
  cursor: pointer;
  display: block;
  height: 0.5rem;
  padding: 0;
  transition: all ${({ transitionTime }) => transitionTime}s ease;
  width: 0.5rem;

  &:hover,
  &:focus,
  &[data-selected='true'] {
    background-color: currentcolor;
    opacity: 50%;
  }

  &[data-selected='true'] {
    width: 3.75rem;
  }
`;
//# sourceMappingURL=Carousel.styles.js.map